module.exports = __webpack_public_path__ + "h5/img/yhk.25014855.png";